import { render, staticRenderFns } from "./toaster.vue?vue&type=template&id=b3854260"
import script from "./toaster.vue?vue&type=script&lang=js"
export * from "./toaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports